<template>
  <div id="ticket-cost-infos">
    <div v-for="ticketCost in chatTicketCost" :key="ticketCost.id">
      <div class="contact__avatar mr-1">
        <vs-row class="mt-2" vs-type="flex" vs-justify="center">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
            <vs-avatar
                v-if="ticketCost && ticketCost.user && ticketCost.user.image"
                class="border-2 border-solid border-white"
                :src="ticketCost.user.image"
                size="60px"
            />
            <vs-avatar v-else class="border-2 border-solid border-white" size="60px"/>
            <div class="chat-ack-container">
              <i class="cost-icon material-icons"
                 :class="ticketCost['ticket_is_open'] ? 'text-warning' : 'text-success'">
                {{ icon(ticketCost) }}
              </i>
            </div>
            <div class="ml-2">
              <div>
                <p v-if="ticketCost && ticketCost.user && ticketCost.user.name">
                  Com <b>{{ ticketCost.user.name }}</b> há <b>{{ parseTime(ticketCost['created_at']) }}</b>
                </p>
                <p v-else>
                  <b class="text-warning">Sem atendente</b> há <b>{{ parseTime(ticketCost['created_at']) }}</b>
                </p>
              </div>
              <div class="text-left text-sm template-item">
                <li> Tipo: {{ type(ticketCost) }}</li>
                <li> Valor: {{ maskMoney(ticketCost) }}</li>
                <li> Conexão: {{ ticketCost['instance']['name'] | truncate(20) }}</li>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>

import {maskMoney, parseTime} from "@/utils";

export default {
  name: "ticket-cost-infos",
  props: {
    chatTicketCost: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    }
  },
  methods: {
    parseTime,
    type(ticketCost){
      if (ticketCost['cost_utility_brl'] > 0) { return 'Transacional' }
      return ticketCost['business_initiated'] ? 'Iniciado' : 'Recebido'
    },
    maskMoney(ticketCost) {
      if (ticketCost['cost_user_brl'] > 0) {
        return maskMoney(ticketCost['cost_user_brl'], 'BRL', 1)
      } else if (ticketCost['cost_business_brl'] > 0) {
        return maskMoney(ticketCost['cost_business_brl'], 'BRL', 1)
      } else if (ticketCost['cost_utility_brl'] > 0) {
        return maskMoney(ticketCost['cost_utility_brl'], 'BRL', 1)
      }
      return maskMoney(0, 'BRL', 1);
    },
    icon(ticketCost) {
      if (ticketCost['ticket_is_open']) {
        return 'play_arrow'
      }
      return 'done'
    }
  }
}
</script>

<style scoped lang="scss">
#ticket-cost-infos {
  .text-gray {
    color: #626262 !important
  }
  .cost-icon {
    font-size: 15px;
    display: flex;
    margin-top: 4.4em;
    margin-left: -1.1em;
  }
}
</style>